export default __webpack_public_path__ + "static/media/ab-white.53fbcba4.svg";